import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GetCareNowFormatService } from '../../../../get-care-now-feature/utilities/getcarenow-format.service';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';
import { environment } from '../../../../../environments/environment';
import { PostGetProviderDetailsRequest } from '../../../../shared/model/providerlocationsearch/PostGetProviderDetailRequest';
import { MCAppGatewayService } from '../../../../shared/services/mcappgateway/mcappgateway.service';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { LocationCoordinates } from '../../../../shared/model/LocationCoordinates';

@Component({
  selector: 'app-provider-search-results-card-mobile',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './provider-search-results-card.component.html',
  styleUrl: './provider-search-results-card.component.css'
})
export class ProviderSearchResultsCardComponent {
  private router = inject(Router);

  @Input() provider!: any;
  @Input() isPlus: boolean = false;
  @Input() currentLocation: LocationCoordinates | null = null;
   @Input() queryCityOrZip!: any;

  public eptID: string = '';
  public soonAsText: string = 'AS_SOON_AS';
  public milesAwayText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';
  public noAvailabilityStr: string = 'Call to schedule';  
  public waitTime: string = '';

  mcAppGateway = inject(MCAppGatewayService);
  searchState = inject(SearchStateService);

  private getCareNowFormatService: GetCareNowFormatService;
  
  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem('locale') || 'en-US'); // Default to 'en-US' if no locale is provided
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }

  ngOnInit() {
    this.eptID = sessionStorage.getItem("eptID") ?? "";

    this.waitTime = this.getCareNowFormatService.formatNextAvailability(this.provider.nextAvailability);
  
      this.translate.get('BOOK_AS_SOON_AS').subscribe((translated: string) => {
        this.soonAsText = translated;
      });
  
      this.translate.get('MILES_AWAY').subscribe((translated: string) => {
        this.milesAwayText = translated;
      });
  
      this.translate.get('SCHEDULE').subscribe((translated: string) => {
        this.scheduleText = translated;
      });

      this.translate.get('CALL_TO_SCHEDULE').subscribe((translated: string) => {
        this.noAvailabilityStr = translated;
      });
  }

  onCallPhone(event: Event): void {
    event.stopPropagation();
    console.log("Calling phone", this.provider)
    if (this.provider && this.provider.phone) {
      const phoneNumber = this.provider.phone.replace(/\D/g, ''); // Remove non-numeric characters
      console.log('Calling phone number:', phoneNumber);
      window.location.href = `tel:${phoneNumber}`;
    } else {
      console.error('No phone number available for this location');
    }
  }
  

  onScheduleButtonClicked() {
    const isMobileLaunch = window.location.href.includes('mobile');

    if (this.provider && this.provider.providerEmrId && this.provider.providerEmrId.length > 0) {

      if (this.eptID != null && this.eptID != ""){
        if (window.location.href.includes('mobile')) {
          this.scheduleAuth(this.isPlus);
        }
        else {
          this.scheduleAuth(null);
        }
      }
      else {
        this.scheduleUnAuth(isMobileLaunch);  
      }
    }
  }

  scheduleAuth(isPlus: boolean | null) {
    var deepLink = ''; 

    if (isPlus == null) {
      deepLink = environment.web_scheduling_deep_link_base_url;
    }
    else {
       deepLink = isPlus
        ? environment.mobile_scheduling_deep_link_base_url // For Plus users, use the mobile deep link
        : environment.epic_scheduling_deep_link_base_url; //  For non-Plus users, use the epic deep link
    }

    deepLink += "?workflow=NewProvider"

    deepLink += "&selProvId=" + this.provider.providerEmrId; 
      
    if (this.provider.departmentId != null && this.provider.departmentId != '') {
      deepLink += "&selDepId=" + this.provider.departmentId;
    }

    if (this.provider.specialtyId != null && this.provider.specialtyId != '') {
      deepLink += "&selSpecialtyId=" + this.provider.specialtyId;
    }

    var searchMethod = sessionStorage.getItem('providerSearchMethod') ?? '';

    if (searchMethod.length > 0) {
      if (searchMethod === 'freeText') {
        deepLink += "&linksource=AUTHHMPLFRSPC";
      }
      else if (searchMethod === 'quickSearch') {
        deepLink += "&linksource=AUTHHMPLQSPC";
      }
    }

    window.location.href = deepLink;
  }

  scheduleUnAuth(isMobile: boolean) {
    var deepLink = environment.web_open_scheduling_deep_link_base_url 
      + "?id=" + this.provider.providerEmrId;

    if (this.provider.departmentId != null && this.provider.departmentId != '') {
      deepLink += "&dept=" + this.provider.departmentId;
    }

    if (this.provider.specialtyId != null && this.provider.specialtyId != '') {
      deepLink += "&specialty=" + this.provider.specialtyId;
    }

    var searchMethod = sessionStorage.getItem('providerSearchMethod') ?? '';

    if (searchMethod.length > 0) {
      if (searchMethod === 'freeText') {
        deepLink += "&linksource=PLUAFPLOXFTPROV";
      }
      else if (searchMethod === 'quickSearch') {
        deepLink += "&linksource=PLUAFPLOCQSPROV";
      }
    }

    window.location.href = deepLink;
  }

  onGetDirections(event: Event) {
    event.stopPropagation();

    if (this.provider && this.provider.address1) {
      const address = encodeURIComponent(this.provider.address1);
      window.location.href = `https://www.google.com/maps/dir/?api=1&destination=${address}`;
    } else {
      console.error('No address available for this provider');
    }
  }

  viewProviderDetails() {
    console.log('Viewing details for provider:', this.provider);

    window.scrollTo({ top: 50, behavior: 'smooth' });

    this.searchState.setCurrentProviderDetails(this.provider);
    this.searchState.setShowSpinner(true);

    var providerDetailsRequest = new PostGetProviderDetailsRequest();
    providerDetailsRequest.providerID = this.provider.providerId;
    providerDetailsRequest.cityOrZip = this.queryCityOrZip;

    // TODO - set the lat/lon based on the city zip 
    // providerDetailsRequest.latitude = cityZipLatitude;
    // providerDetailsRequest.longitude = cityZipLongitude;

    console.log("Provider Details Request:", providerDetailsRequest);

    this.mcAppGateway.PostGetProviderDetails(providerDetailsRequest).subscribe({
      next: (response) => {
        console.log('Provider Details Response:', response);
        
        // Handle the response as needed
        this.searchState.setCurrentProviderDetails(response);
        this.searchState.setShowSpinner(false);
      },
      error: (error) => {
        console.error('Error fetching provider details:', error);
        alert('An error occurred while fetching provider details. Please try again later.');
        this.searchState.setShowSpinner(false);
        this.searchState.clearCurrentProviderDetails();
      }
    });
  }
}
